import styled, { css } from 'styled-components';
import { DropdownItem as DropdownItemBase } from 'reactstrap';

const VALID_STICKY_VALUES = ['top', 'bottom'] as const;

export const isValidSticky = (value?: string): value is 'top' | 'bottom' => {
  return !!value && (VALID_STICKY_VALUES as readonly string[]).includes(value);
};

const DropdownItem = styled(DropdownItemBase)<{ $sticky?: 'top' | 'bottom' }>`
  &:active,
  &:focus {
    background-color: ${({ theme }): string => theme.designSystem.bgColors.comboboxToken};
    border: none;
    outline: none;
  }

  &:hover {
    background-color: ${({ theme }): string => theme.designSystem.bgColors.pageBody};
    border: none;
    outline: none;
  }

  &:disabled {
    color: ${({ theme }): string => theme.designSystem.textColors.disabled} !important;
  }

  ${({ $sticky, theme }) => {
    if (!isValidSticky($sticky)) return null;

    const isTop = $sticky === 'top';
    const borderSide = isTop ? 'bottom' : 'top';

    return css`
      position: sticky;
      ${$sticky}: 0;
      z-index: 10;
      align-self: ${isTop ? 'flex-start' : 'flex-end'};
      background-color: ${theme.designSystem.bgColors.card} !important;
      
      border-${borderSide}: 1px solid ${theme.designSystem.borderColors.menu} !important;

      &:hover,
      &:active {
        background-color: ${theme.designSystem.bgColors.pageBody} !important;
        border-${borderSide}: 1px solid ${theme.designSystem.borderColors.menu} !important;
      }

      &:focus {
        background-color: ${theme.designSystem.bgColors.comboboxToken} !important;
        outline: 2px solid ${theme.designSystem.borderColors.menu};
        outline-offset: -2px; 
      }
    `;
  }}
`;

export default DropdownItem;
